import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Expression } from 'src/app/i18/messages';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  mode: string = '';
  actionCode: string = '';
  lang: string = 'en';
  platform: string = '';

  ngUnsubscribe: Subject<any> = new Subject<any>();
  
  actionCodeChecked: boolean = false;
  verifiedStatus: boolean = false;
  pwdUpdateStatus: boolean = false;

  message: string = '';

  password: string = '';

  toggleEye: boolean = true;

  constructor(
    private auth: AngularFireAuth,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(params => {
        // if we didn't receive any parameters, 
        // we can't do anything
        if (!params) this.router.navigate(['/']);

        this.mode = params['mode'];
        this.actionCode = params['oobCode'];
        this.lang = params['lang'];
        this.platform = params['platform']
        
        switch (params['mode']) {
          case 'resetPassword': {
            // Verify the password reset code is valid.
            this.auth.verifyPasswordResetCode(this.actionCode).then(email => {
              this.actionCodeChecked = true;
            }).catch(err => {
              // Invalid or expired action code.
              //Ask user to try to reset the password again.
             this.toastr.warning(this.getText('tryAgain'), this.getText('invalidCode'));

              // redirect user to page where they can input their email address
              // TODO
            });
          } break
          case 'verifyEmail': {

            this.auth.applyActionCode(this.actionCode)
              .then((resp) => {
                this.message = this.getText('emailVerified')
                this.verifiedStatus = true;
              })
              .catch(err => {
                this.verifiedStatus = false;
                this.message = this.getText('emailAlreadyVerified')
                this.toastr.warning(this.getText('emailCodeExpired'), this.getText('invalidCode'));
              })

          } break
          default: {
            // console.log('query parameters are missing');
          }
        }
      });
  }


  savePassword() {
    this.spinner.show();
    if(!this.password) {
      this.spinner.hide();
      return this.toastr.warning(this.getText('passwordReuired'));
    }

    if(this.password.length < 8) {
      this.spinner.hide();
      return this.toastr.warning(this.getText('passwordLength'));
    }

    if(this.checkPasswordValidity(this.password)) {
      this.spinner.hide();
      return
    }

    return this.auth.confirmPasswordReset(this.actionCode, this.password)
      .then(() => { 
        this.spinner.hide();
        this.toastr.success(this.getText('passwordUpdated'));
        this.password = '';
        this.pwdUpdateStatus = true
        // TODO: (Optional) navigate user back to login
      })
      .catch(err => {
        this.spinner.hide();

        if(err.code == 'auth/invalid-action-code') {
          return this.toastr.warning(this.getText('passwordResetInvalidCode'), this.getText('invalidCode'))
        }
        return this.toastr.warning(err.message, 'Uh oh!')
      });
  }

  checkPasswordValidity(pass: string) {
    const isNonWhiteSpace = /^\S*$/;
    if (!isNonWhiteSpace.test(pass)) {
      return this.toastr.warning(this.getText('passwordNoWhitespace'));
    }
  
    const isContainsUppercase = /^(?=.*[A-Z]).*$/;
    if (!isContainsUppercase.test(pass)) {
      return this.toastr.warning(this.getText('passwordWithUppercase'));
    }
  
    const isContainsLowercase = /^(?=.*[a-z]).*$/;
    if (!isContainsLowercase.test(pass)) {
      return this.toastr.warning(this.getText('passwordWithLowercase'));
    }
  
    const isContainsNumber = /^(?=.*[0-9]).*$/;
    if (!isContainsNumber.test(pass)) {
      return this.toastr.warning(this.getText('passwordWithDigit'));
    }
  
    return null;
  }

  toggleEyeIcon(inputPassword:any) {
		this.toggleEye = !this.toggleEye;
		
		inputPassword.type = inputPassword.type === 'password' ? 'text' : 'password';
	}

  ngOnDestroy() {
    // End all subscriptions listening to ngUnsubscribe
    // to avoid memory leaks.
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  getText(key: string) {
    return Expression.getText(key, this.lang)
  }

  hasPlatform(): boolean {
    //console.log('platform: ', this.platform)
    return this.platform.length > 0;
  }

  continueToApp() {
    window.open(`${environment.appLinkBaseUrl}/?action=nav&type=login&lang=${this.lang}`, "_self");
  }
}
